import { Injectable } from '@angular/core';
import { moment } from '@app/lib/moment';

@Injectable({providedIn: 'root'})
export class TimeZoneFormatService {

  public formatToTimeZone(
    timeZone: string,
    dateString: string,
    outputDateFormat: string,
    isEndDate: boolean = false,
    defaultReturn: string = '',
    inputDateFormat: string = '',
  ): string {
    if (!dateString) {
      return defaultReturn;
    }

    let dateTime = moment.mapTz(dateString, inputDateFormat, timeZone);
    if (isEndDate) {
      dateTime = this.computeDateIfMidnight(dateTime);
    }
    return dateTime.format(outputDateFormat);
  }

  public formatToTimeZoneAndAddDays(
    timeZone: string,
    dateString: string,
    outputDateFormat: string,
    numberOfDays: number,
  ): string {
    let dateTime = moment.mapTz(dateString, '', timeZone);
    dateTime = dateTime.add(numberOfDays, 'days');
    return dateTime.format(outputDateFormat);
  }

  public detailedFormatBillingCycleDates(timeZone: string, startDateTimeString: string, endDateTimeString: string): string {
    if (!startDateTimeString || !endDateTimeString) {
      return '';
    }

    const startDateTime = moment.mapTz(startDateTimeString, '', timeZone);
    let endDateTime = moment.mapTz(endDateTimeString, '', timeZone);
    endDateTime = this.computeDateIfMidnight(endDateTime);

    return startDateTime.format('MM/DD/YYYY') + '–' + endDateTime.format('MM/DD/YYYY');
  }


  public formatBillingCycleDates(timeZone: string, startDateTimeString: string, endDateTimeString: string): string {
    if (!startDateTimeString || !endDateTimeString) {
      return '';
    }

    const startDateTime = moment.mapTz(startDateTimeString, '', timeZone);
    let endDateTime = moment.mapTz(endDateTimeString, '', timeZone);
    endDateTime = this.computeDateIfMidnight(endDateTime);
    if (startDateTime.year() != endDateTime.year()) {
      return startDateTime.format('MMM DD, YYYY') + ' - ' + endDateTime.format('MMM DD, YYYY');
    } else {
      return startDateTime.format('MMM DD') + ' - ' + endDateTime.format('MMM DD, YYYY');
    }
  }

  public formatPaginationBillingCycleDates(timeZone: string, startDateTimeString: string, endDateTimeString: string): string {
    if (!startDateTimeString || !endDateTimeString) {
      return '';
    }

    const startDateTime = moment.mapTz(startDateTimeString, '', timeZone);
    let endDateTime = moment.mapTz(endDateTimeString, '', timeZone);
    endDateTime = this.computeDateIfMidnight(endDateTime);
    return startDateTime.format('MMM YYYY') + ' - ' + endDateTime.format('MMM YYYY');
  }

  public formatPaginationPaymentDates(timeZone: string, firstPaymentDateString: string, lastPaymentDateString: string): string {
    if (!firstPaymentDateString && !lastPaymentDateString) {
      return '-';
    } else if (!!firstPaymentDateString && !!lastPaymentDateString) {
      const firstPaymentDate = moment.mapTz(firstPaymentDateString, '', timeZone);
      let lastPaymentDate = moment.mapTz(lastPaymentDateString, '', timeZone);
      lastPaymentDate = this.computeDateIfMidnight(lastPaymentDate);
      return firstPaymentDate.format('MMM YYYY') + ' - ' + lastPaymentDate.format('MMM YYYY');
    }
    let paymentDate;
    if (!!firstPaymentDateString) {
      paymentDate = moment.mapTz(firstPaymentDateString, '', timeZone);
    } else {
      paymentDate = moment.mapTz(lastPaymentDateString, '', timeZone);
    }
    return paymentDate.format('MMM YYYY');
  }

  private computeDateIfMidnight(dateTime) {
    // Check if end date is at midnight, If true then show the previous date
    if (dateTime.hours() === 0 && dateTime.minutes() === 0 && dateTime.seconds() === 0) {
      dateTime = dateTime.subtract(1, 'days');
    }
    return dateTime;
  }
}
